import CryptoJS from 'crypto-js';

export const encryptMessage = function (messageToencrypt) {
    var encryptedMessage = CryptoJS.AES.encrypt(messageToencrypt, 'itisaverybigsecretwhichicannottellyou');
    return encryptedMessage.toString();
}

export const decryptMessage = function (encryptedMessage) {
    var decryptedBytes = CryptoJS.AES.decrypt(encryptedMessage, 'itisaverybigsecretwhichicannottellyou');
    var decryptedMessage = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedMessage;
}